import { IntlProvider } from "react-intl";
import { Route, Routes } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Main from "./pages/Main/Main";
import { useSelector } from "react-redux";

function App() {
	const { messages, currentLocale } = useSelector((state) => state.locale);
	return (
		<IntlProvider locale={currentLocale} messages={messages[currentLocale]}>
			<Router>
				<Routes>
					<Route path='/' element={<Main />} />
				</Routes>
			</Router>
		</IntlProvider>
	);
}

export default App;
